import { render, staticRenderFns } from "./ProjectsPrimaryBanner.vue?vue&type=template&id=d7a2a90a&scoped=true"
import script from "./ProjectsPrimaryBanner.vue?vue&type=script&lang=js"
export * from "./ProjectsPrimaryBanner.vue?vue&type=script&lang=js"
import style0 from "./ProjectsPrimaryBanner.vue?vue&type=style&index=0&id=d7a2a90a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a2a90a",
  null
  
)

export default component.exports